export function* generateRandomId() {
	while (true) {
		yield Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
	}
}
